// CustomAutocomplete.js
import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useMediaQuery } from "@mui/material";

const CustomAutocomplete = ({ options, value, onChange, label, id }) => {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  return (
    <span style={{ minWidth: isMediumScreen ? "240px" : "150px" }}>
    <Autocomplete
      id={id}
      disablePortal
      options={options||[]}
      // getOptionLabel={(option) => option.label}
      value={value}
      onChange={onChange}
      // isOptionEqualToValue={(option, value) =>
      //    option.label === value?.label && option.value === value.value
      // }
      renderInput={(params) => <TextField {...params} label={label} />}
    />
    </span>
  );
};

export default CustomAutocomplete;
